/** Shared loading/error UI components for route rendering */
import { Loader2 } from "./ui/loader2";
import { splashWanted } from "./PwaLogo";

export const LazyFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50">
    <Loader2 className="w-12 h-12 text-[#074E3B] animate-spin" />
  </div>
);

/** Fallback for the login screens: when the PWA launch intro is about to play, show the plain intro background (no spinner flash before the logo). */
export const LaunchFallback = () => (splashWanted()
  ? <div className="min-h-screen bg-[#F4F8F6]" data-testid="launch-fallback" />
  : <LazyFallback />);

export const TenantLoading = ({ slug }) => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="tenant-loading">
    <div className="text-center">
      <Loader2 className="w-14 h-14 text-[#074E3B] animate-spin mx-auto mb-4" />
      <p className="text-slate-600">Laddar {slug}...</p>
    </div>
  </div>
);

export const TenantError = ({ slug }) => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="tenant-error">
    <div className="max-w-sm w-full text-center bg-white rounded-2xl shadow-lg border border-slate-100 p-10">
      <div className="w-14 h-14 mx-auto mb-5 rounded-xl bg-red-50 flex items-center justify-center">
        <svg className="w-7 h-7 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <h2 className="text-lg font-bold text-slate-800 mb-2">Företaget hittades inte</h2>
      <p className="text-sm text-slate-500 mb-6">Adressen <strong>/t/{slug}</strong> är inte kopplad till något registrerat företag.</p>
      <button onClick={() => window.location.href = '/'} className="px-6 py-2.5 bg-slate-800 text-white text-sm font-medium rounded-lg hover:bg-slate-700 transition-colors">
        Gå till plattformen
      </button>
    </div>
  </div>
);

